export default "__VITE_ASSET__CRgcd1NP__"